const endpoints = {
  activities: '/v1/monitoring/activities',
  events: '/v1/monitoring/events',
  tasks: '/v1/monitoring/tasks',
  sites: '/v1/monitoring/sites',
  samplingAreas: '/v1/samplingAreas',
  exclusionAreas: '/v1/exclusionAreas',
  monitoringExportForSoc: '/v1/monitoring/sites/exportForSoc',
  farms: '/v1/farms',
  farmOwners: '/v1/farmOwners',
  paddocks: '/v1/paddocks',
  farmSubdivisions: '/v1/farmSubdivisions',
  farmSubdivisionsTemplate: '/v1/farmSubdivisions/template',
  metricEvents: '/v1/metrics',
  metricsByPaddockId: '/v1/metricsByPaddockId',
  otherPolygons: '/v1/otherPolygons',
  otherSites: '/v1/otherSites',
  users: '/v1/admin/users',
  workflows: '/v1/refData/workflows',
  programConfig: '/v1/programConfig',
  formDefinitions: '/v1/formDefinitions',
  deal: '/v1/deals',
  programs: '/v1/programs',
  objectStore: '/v1/objectStore',
  soils: '/v1/geographics/soils',
  stratification: {
    vectorize: '/v1/stratification/georaster/vectorize',
    stratifyFarm: '/v1/stratification/stratas/stratifyFarm',
  },
  dataCollectionStatements: '/v1/datacollectionStatements',
  findings: '/v1/findings',
  findingComments: '/v1/findingComments',
  documents: '/v1/documents',
  compareGpsData: '/v1/monitoring/sites/compare-gps',
  monitoringSOCSamples: '/v1/monitoring/SOCSamples',
  metricsProvider: '/v1/metricsProvider',
  carbonInstances: '/v1/carbonInstances',
  programMonitoringPeriods: '/v1/programMonitoringPeriods',
  randomizerVersion: '/v1/refData/RefRandomizer',
  v2: {
    events: '/v2/monitoring/events',
    monitoring: {
      activities: '/v2/monitoring/activities',
      tasks: '/v2/monitoring/tasks',
      sites: '/v2/monitoring/sites',
      siteName: (siteId: string) => `/v2/monitoring/sites/${siteId}/name`,
    },
    randomize: {
      v4Generate: '/v2/randomize/v4/generate',
    },
    rawDataCollection: '/v2/raw-data-collection',
    refData: (key: string) => `/v2/ref-data/${key}`,
    farms: {
      list: '/v2/farms',
      filterOptions: '/v2/farms/filter-options',
      blockedMonitoringPeriods: (farmId: string) =>
        `/v2/farms/${farmId}/blocked-monitoring-periods`,
      attestationAreas: (farmId: string) => `/v2/farms/${farmId}/attestation-areas`,
      eligibilityCheck: (farmId: string) => `/v2/farms/${farmId}/eligibility-check`,
      otbn: (farmId: string) => `/v2/farms/${farmId}/otbn`,
      clusters: (farmId: string) => `/v2/farms/${farmId}/clusters`,
      quantificationUnits: (farmId: string) => `/v2/farms/${farmId}/quantification-units`,
      exclusionAreaObservationsUnresolvedCount: (farmId: string) =>
        `/v2/farms/${farmId}/exclusion-area-observations/unresolved-count`,
    },
    samplingAreas: {
      effectiveAreas: (farmId: string) => `/v2/sampling-areas/${farmId}/effective-areas`,
    },
    reports: {
      report: (reportId: string) => `/v2/reports/${reportId}`,
      templates: '/v2/reports/templates',
    },
    setAuthCookie: '/v2/set-auth-cookie',
    quantificationUnits: {
      hints: '/v2/quantification-units/hints',
    },
    exclusionAreas: {
      observations: (exclusionAreaId: string) =>
        `/v2/exclusion-areas/${exclusionAreaId}/observations`,
    },
    exclusionAreaObservations: {
      resolve: (observationId: string) =>
        `/v2/exclusion-area-observations/${observationId}/resolve`,
      comments: (observationId: string) =>
        `/v2/exclusion-area-observations/${observationId}/comments`,
    },
    farmSubdivisions: {
      partialImport: (farmSubdivisionId: string) =>
        `/v2/farmSubdivisions/${farmSubdivisionId}/partial-import`,
    },
  },
}

export default endpoints
